import cleverTapAnalytics from "@services/analytics";

const constants = {
  CP_NEXT_DAY_MODAL_VIEWED: "CP Availability Next Day Modal Viewed",
  CP_NEXT_DAY_MODAL_ACTION: "CP Availability Next Day Modal Action",
  CP_NEXT_DAY_MODAL_CLOSED: "CP Availability Next Day Modal Closed",
  CP_NEXT_DAY_CHIP_CLICKED: "CP Availability Next Day Chip Clicked",
};

const actions = {
  modalViewed: (payload) =>
    cleverTapAnalytics.trackEvent(constants.CP_NEXT_DAY_MODAL_VIEWED, payload),
  modalClosed: (payload) =>
    cleverTapAnalytics.trackEvent(constants.CP_NEXT_DAY_MODAL_CLOSED, payload),
  modalAction: (payload) =>
    cleverTapAnalytics.trackEvent(constants.CP_NEXT_DAY_MODAL_ACTION, payload),
  chipClicked: (payload) =>
    cleverTapAnalytics.trackEvent(constants.CP_NEXT_DAY_CHIP_CLICKED, payload),
};

export default actions;
